/* FitFinder — size & fit finder for BLACKSTONE.
   Self-contained. Chart and settings arrive from shop metafields via the
   snippet, so nothing about your sizing is hard-coded here. */
(function (W, D) {
  'use strict';
  if (W.FitFinder) return;

  /* Regional pattern blocks: cm deltas against the EU/ISO reference at the
     same girth. These describe how garments are DRAFTED, not individuals. */
  var REGIONS = {
    gulf:          { l: 'Gulf / GCC',             a: 'الخليج',         sh: 0.4,  sl: 0.5,  ins: 0,    to: 0.5 },
    levant:        { l: 'Levant & Egypt',         a: 'الشام ومصر',     sh: 0.2,  sl: 0,    ins: -0.5, to: 0 },
    northAfrica:   { l: 'North Africa',           a: 'المغرب العربي',  sh: 0,    sl: -0.5, ins: -1,   to: 0 },
    turkeyIran:    { l: 'Türkiye & Iran',         a: 'تركيا وإيران',   sh: 0.2,  sl: 0,    ins: -0.5, to: 0 },
    southAsia:     { l: 'South Asia',             a: 'جنوب آسيا',      sh: -1,   sl: -2,   ins: -3,   to: -1 },
    eastAsia:      { l: 'East Asia',              a: 'شرق آسيا',       sh: -1.5, sl: -2.5, ins: -3.5, to: -2 },
    southeastAsia: { l: 'Southeast Asia',         a: 'جنوب شرق آسيا',  sh: -1.8, sl: -3,   ins: -4.5, to: -2 },
    western:       { l: 'Europe / North America', a: 'أوروبا وأمريكا', sh: 0,    sl: 0,    ins: 0,    to: 0 }
  };

  /* Body types. w = silhouette widths (shoulder, bust, waist, hip). */
  var SW = [
    { id: 'hourglass', l: 'Hourglass', a: 'الساعة الرملية', w: [0.72,0.86,0.52,0.86],
      ad: 'Size to whichever of bust or hip is larger; the waist is the easiest place to take a garment in.',
      adA: 'اختر المقاس حسب الأكبر بين الصدر والأرداف؛ الخصر أسهل موضع للتضييق.',
      c: 'Very common across the Gulf, the Levant and South Asia.' },
    { id: 'bottomHourglass', l: 'Bottom Hourglass', a: 'ساعة رملية سفلية', w: [0.68,0.80,0.52,0.90],
      ad: 'Buy dresses to the hip, then take in the bodice. Separates are usually better value.',
      adA: 'اشترِ الفساتين حسب الأرداف ثم ضيّق الجزء العلوي. القطع المنفصلة عادةً أفضل.',
      c: 'The most frequently reported shape in GCC and South Asian fit studies.' },
    { id: 'topHourglass', l: 'Top Hourglass', a: 'ساعة رملية علوية', w: [0.80,0.90,0.54,0.80],
      ad: 'Size to the bust for anything closing across the chest; expect a roomy waist and hip.',
      adA: 'اختر المقاس حسب الصدر في أي قطعة تُغلق من الأمام؛ توقّع اتساعًا عند الخصر والأرداف.',
      c: 'Seen across the Levant, Türkiye and Iran.' },
    { id: 'spoon', l: 'Spoon', a: 'الملعقة', w: [0.66,0.78,0.54,0.94],
      ad: 'The high hip, not the full hip, is what blocks a zip. Look for stretch and A-line cuts.',
      adA: 'أعلى الأرداف لا محيطها الكامل هو ما يعيق السحّاب. ابحث عن الأقمشة المطاطة والقصّات الواسعة.',
      c: 'Frequently identified in South Asian and Gulf sizing research.' },
    { id: 'pear', l: 'Pear', a: 'الكمثرى', w: [0.62,0.72,0.62,0.92],
      ad: 'Buy bottoms to the hip and accept a loose waistband — taking a waistband in is cheap and quick.',
      adA: 'اشترِ البناطيل حسب الأرداف واقبل باتساع الخصر — تضييق حزام الخصر تعديل رخيص وسريع.',
      c: 'The most common shape reported across South Asia and North Africa.' },
    { id: 'invertedTriangle', l: 'Inverted Triangle', a: 'المثلث المقلوب', w: [0.90,0.88,0.68,0.72],
      ad: 'Size to the shoulder and bust on tops; you can usually drop a size in bottoms.',
      adA: 'اختر المقاس حسب الكتف والصدر في القطع العلوية؛ يمكنك النزول مقاسًا في البناطيل.',
      c: 'Common among athletic builds worldwide.' },
    { id: 'rectangle', l: 'Rectangle', a: 'المستطيل', w: [0.74,0.78,0.68,0.80],
      ad: 'You have the widest choice. Pick the smaller size for structure, the larger for drape.',
      adA: 'لديك أوسع الخيارات. اختر الأصغر لشكل محدد والأكبر لانسدال أكثر.',
      c: 'The most common shape in East and Southeast Asian fit studies.' },
    { id: 'apple', l: 'Apple', a: 'التفاحة', w: [0.78,0.84,0.88,0.80],
      ad: 'Size to the waist and let everything else be loose. Empire lines fit best off the rack.',
      adA: 'اختر المقاس حسب الخصر ودع الباقي واسعًا. القصّات العالية الخصر هي الأنسب جاهزة.',
      c: 'Prevalence rises with age in every region studied, notably the GCC and Egypt.' },
    { id: 'diamond', l: 'Diamond', a: 'الماسة', w: [0.66,0.78,0.86,0.78],
      ad: 'Shoulder fit is your anchor — buy for the shoulder and have the body adjusted.',
      adA: 'قياس الكتف هو مرجعك — اشترِ حسب الكتف ثم عدّل الجسم.',
      c: 'Recorded across the Levant, Türkiye and Central Asia.' }
  ];

  var SM = [
    { id: 'trapezoid', l: 'Athletic', a: 'رياضي', w: [0.92,0.88,0.70,0.78],
      ad: 'Buy shirts to the chest and have the waist darted. Slim-fit lines usually work as-is.',
      adA: 'اشترِ القمصان حسب الصدر وضيّق الخصر. القصّات الضيقة تناسبك عادةً دون تعديل.',
      c: 'Common across the Gulf and Levant.' },
    { id: 'invertedTriangleM', l: 'Inverted Triangle', a: 'المثلث المقلوب', w: [0.98,0.92,0.66,0.72],
      ad: 'A shirt that fits the shoulder will billow at the waist. Athletic-fit lines exist for this.',
      adA: 'القميص الذي يناسب كتفك سيتّسع عند الخصر. ابحث عن خطوط athletic fit.',
      c: 'Athletic builds worldwide.' },
    { id: 'rectangleM', l: 'Rectangle', a: 'المستطيل', w: [0.82,0.82,0.76,0.80],
      ad: 'Widest off-the-rack choice. Regular fit is your default.',
      adA: 'أوسع خيارات جاهزة. القصّة العادية هي خيارك الافتراضي.',
      c: 'The most common build in East, Southeast and South Asia.' },
    { id: 'ovalM', l: 'Oval', a: 'البيضاوي', w: [0.82,0.88,0.94,0.86],
      ad: 'Size to the waist, then have the shoulders and chest taken in — the reverse costs far more.',
      adA: 'اختر المقاس حسب الخصر ثم ضيّق الكتفين والصدر — العكس أغلى بكثير.',
      c: 'Prevalence rises with age across the GCC and South Asia.' },
    { id: 'triangleM', l: 'Triangle', a: 'المثلث', w: [0.74,0.78,0.84,0.88],
      ad: 'Structured shoulders and a mid rise balance the line. Avoid low rise.',
      adA: 'الأكتاف المهيكلة والخصر المتوسط يوازنان الشكل. تجنّب الخصر المنخفض.',
      c: 'Seen across all regions.' }
  ];

  var CATS = {
    tops:      { l: 'Tops & shirts',        a: 'بلوزات وقمصان',  wt: { bust: 0.6, chest: 0.6, waist: 0.15, hip: 0.05 } },
    bottoms:   { l: 'Trousers & skirts',    a: 'بناطيل وتنانير', wt: { waist: 0.45, hip: 0.55 } },
    dresses:   { l: 'Dresses & one-pieces', a: 'فساتين',         wt: { bust: 0.36, waist: 0.28, hip: 0.36 } },
    outerwear: { l: 'Jackets & coats',      a: 'جاكيتات ومعاطف', wt: { bust: 0.6, chest: 0.6, waist: 0.15, hip: 0.1 } },
    abaya:     { l: 'Abaya & modest wear',  a: 'عبايات',         wt: { bust: 0.5, hip: 0.5 } }
  };

  var FITS = [
    { id: 'slim',    l: 'Fitted',  a: 'ضيق',  d: 'Close to the body' },
    { id: 'regular', l: 'Regular', a: 'عادي', d: 'As designed' },
    { id: 'relaxed', l: 'Relaxed', a: 'واسع', d: 'Room to move' }
  ];

  var T = {
    en: { title: 'Find my size', sub: 'A few numbers and we will tell you which size to add to the bag.',
      back: 'Back', next: 'Continue', see: 'See my size', again: 'Start over', done: 'Done',
      who: 'Who are we sizing?', women: 'Women', men: 'Men',
      regionQ: 'Where are you shopping from?',
      regionH: 'Pattern blocks differ by region. This is what lets us warn you when a sleeve or inseam will run long.',
      measQ: 'Your measurements', measH: 'Measure over light clothing, tape snug but not tight.',
      tape: 'I measured', est: 'Estimate for me',
      estH: 'We will estimate from height, weight and build. Less accurate than a tape, but a solid start.',
      height: 'Height', weight: 'Weight', build: 'Build', bust: 'Bust', chest: 'Chest',
      waist: 'Waist', hip: 'Hip', opt: '(optional)',
      shapeQ: 'Your body type', shapeH: 'We picked the closest match from your numbers. Change it if you disagree.',
      fitQ: 'How do you like clothes to fit?',
      your: 'Your size', alt: 'If in doubt', conf: 'Confidence',
      fits: 'How this size will fit you', you: 'you', size: 'size', cm: 'cm',
      conv: 'The same size around the world', guide: 'How to measure',
      save: 'Save my measurements', saved: 'Saved on this device',
      apply: 'Select size {s} on this page',
      oos: 'This style is not cut in {s}. The closest size we make is {a} — it will be {d}, so check the fit notes above before ordering.',
      tighter: 'a little tighter than ideal', looser: 'a little roomier than ideal',
      up: 'one up', down: 'one down', auto: 'AUTO', req: 'Required',
      disc: 'Based on our size chart and population averages for garment blocks. Bodies vary and so does the cut of an individual piece — treat this as a strong starting point.',
      slight: 'Slight', avg: 'Average', full: 'Fuller', estIs: 'Estimated:', estWait: 'Enter your height and weight above.' },
    ar: { title: 'اعرف مقاسك', sub: 'أرقام قليلة وسنخبرك بالمقاس المناسب لك.',
      back: 'رجوع', next: 'متابعة', see: 'أظهر مقاسي', again: 'ابدأ من جديد', done: 'تم',
      who: 'لمن نحدد المقاس؟', women: 'نساء', men: 'رجال',
      regionQ: 'من أين تتسوق؟',
      regionH: 'قوالب التفصيل تختلف حسب المنطقة، وهذا ما يتيح لنا تنبيهك إذا كان الكم أو الطول سيأتي أطول.',
      measQ: 'قياساتك', measH: 'قِس فوق ملابس خفيفة، وشدّ الشريط برفق دون ضغط.',
      tape: 'قِستُ نفسي', est: 'قدّر لي',
      estH: 'سنقدّر من الطول والوزن وبنية الجسم. أقل دقة من الشريط لكنه بداية جيدة.',
      height: 'الطول', weight: 'الوزن', build: 'بنية الجسم', bust: 'الصدر', chest: 'الصدر',
      waist: 'الخصر', hip: 'الأرداف', opt: '(اختياري)',
      shapeQ: 'شكل جسمك', shapeH: 'اخترنا الأقرب من أرقامك. غيّره إذا لم توافق.',
      fitQ: 'كيف تحب أن تكون الملابس عليك؟',
      your: 'مقاسك', alt: 'إذا ترددت', conf: 'درجة الثقة',
      fits: 'كيف سيكون هذا المقاس عليك', you: 'أنت', size: 'المقاس', cm: 'سم',
      conv: 'المقاس نفسه حول العالم', guide: 'كيف تقيس',
      save: 'احفظ قياساتي', saved: 'محفوظة على هذا الجهاز',
      apply: 'اختر المقاس {s} في هذه الصفحة',
      oos: 'هذا التصميم غير متوفر بمقاس {s}. أقرب مقاس متاح هو {a} وسيكون {d}، فراجع الملاحظات أعلاه.',
      tighter: 'أضيق قليلًا من المثالي', looser: 'أوسع قليلًا من المثالي',
      up: 'مقاس أكبر', down: 'مقاس أصغر', auto: 'تلقائي', req: 'مطلوب',
      disc: 'بناءً على جدول مقاساتنا ومتوسطات قوالب التفصيل. الأجسام تختلف وكذلك قصّة كل قطعة — اعتبرها نقطة انطلاق قوية.',
      slight: 'نحيف', avg: 'متوسط', full: 'ممتلئ', estIs: 'التقدير:', estWait: 'أدخل الطول والوزن أعلاه.' }
  };

  var CFG = {}, S = null, el = {}, mem = {};
  var KEY = 'fitfinder.profile.v1';

  function store(v) {
    if (v === undefined) {
      if (CFG.persist) { try { var r = W.localStorage.getItem(KEY); return r ? JSON.parse(r) : null; } catch (e) {} }
      return mem[KEY] || null;
    }
    mem[KEY] = v;
    if (CFG.persist) { try { W.localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  }
  function t(k) { return (T[S.lang] || T.en)[k] || T.en[k] || k; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function r1(v) { return Math.round(v * 10) / 10; }

  /* Stores spell the same size differently: 2XL and XXL are one size. */
  function key(v) {
    return String(v == null ? '' : v).trim().toLowerCase()
      .replace(/[\s._-]/g, '')
      .replace(/^(extra|x)(extra|x)?(small|large)$/, function (m, a, b, c) {
        return (b ? 'xx' : 'x') + (c === 'small' ? 's' : 'l');
      })
      .replace(/^(\d)x(l|s)$/, function (m, n, z) { return new Array(+n + 1).join('x') + z; })
      .replace(/^small$/, 's').replace(/^medium$/, 'm').replace(/^large$/, 'l');
  }

  var IN = 2.54;
  function shapeOf(m, g) {
    if (g === 'men') {
      var c = m.chest || m.bust, w = m.waist, h = m.hip || (m.waist + 6);
      if (!c || !w) return null;
      if (w >= c - 2) return 'ovalM';
      if (c - h < -4) return 'triangleM';
      if (c - w >= 28) return 'invertedTriangleM';
      if (c - w >= 15) return 'trapezoid';
      return 'rectangleM';
    }
    var b = m.bust, wa = m.waist, hp = m.hip;
    if (!b || !wa || !hp) return null;
    var hasHH = m.highHip != null, hh = hasHH ? m.highHip : wa + (hp - wa) * 0.4;
    var bh = b - hp, hb = hp - b, bw = b - wa, hw = hp - wa, hr = hh / wa;
    if (bh <= 1 * IN && hb < 3.6 * IN && (bw >= 9 * IN || hw >= 10 * IN)) return 'hourglass';
    if (hb >= 3.6 * IN && hb < 10 * IN && hw >= 9 * IN && (!hasHH || hr < 1.193)) return 'bottomHourglass';
    if (bh > 1 * IN && bh < 10 * IN && bw >= 9 * IN) return 'topHourglass';
    if (hasHH && hb > 2 * IN && hw >= 7 * IN && hr >= 1.193) return 'spoon';
    if (hb >= 3.6 * IN && hw < 9 * IN) return 'pear';
    if (bh >= 3.6 * IN && bw < 9 * IN) return 'invertedTriangle';
    if (wa >= b - 2 && wa >= hp - 2) return 'apple';
    if (hb < 3.6 * IN && bh < 3.6 * IN && bw < 9 * IN && hw < 10 * IN) return 'rectangle';
    if (wa > b * 0.94 && hp - b < 3 * IN) return 'diamond';
    return 'rectangle';
  }
  function shapeById(id, g) {
    var L = g === 'men' ? SM : SW;
    for (var i = 0; i < L.length; i++) if (L[i].id === id) return L[i];
    return null;
  }

  function estimate() {
    var h = num('height'), w = parseFloat(S.m.weight);
    if (!h || isNaN(w)) return null;
    var bmi = w / Math.pow(h / 100, 2);
    var k = 1 + ({ slight: -0.05, average: 0, full: 0.06 }[S.build] || 0);
    var o = { height: h, weight: w, estimated: true };
    if (S.gender === 'men') {
      o.chest = r1((49 + 2.06 * bmi + 0.11 * (h - 175)) * k);
      o.waist = r1((25 + 2.20 * bmi + 0.08 * (h - 175)) * k);
      o.hip = r1((45 + 1.68 * bmi + 0.10 * (h - 175)) * k);
    } else {
      o.bust = r1((44 + 1.86 * bmi + 0.13 * (h - 164)) * k);
      o.waist = r1((21 + 2.10 * bmi + 0.09 * (h - 164)) * k);
      o.hip = r1((49 + 1.82 * bmi + 0.12 * (h - 164)) * k);
    }
    return o;
  }

  function rows() {
    var c = CFG.chart || {};
    var g = c[S.gender] || c.women || c.men || {};
    return g[S.category] || g.tops || g.dresses || g.bottoms || g.outerwear || [];
  }

  function num(k) {
    var v = parseFloat(S.m[k]);
    if (isNaN(v)) return null;
    if (k === 'weight') return v;
    return S.unit === 'in' ? v * 2.54 : v;
  }
  function bodyCm() {
    var o = {};
    ['bust', 'chest', 'waist', 'hip', 'highHip', 'height'].forEach(function (k) {
      var v = num(k); if (v != null) o[k] = r1(v);
    });
    if (S.gender === 'men' && o.chest == null && o.bust != null) o.chest = o.bust;
    if (S.gender !== 'men' && o.bust == null && o.chest != null) o.bust = o.chest;
    return o;
  }

  function recommend() {
    var R = rows(); if (!R.length) return null;
    var body = S.mode === 'estimate' ? (estimate() || {}) : bodyCm();
    var cat = CATS[S.category] || CATS.tops;
    var bias = typeof CFG.chart.bias === 'number' ? CFG.chart.bias : 0;
    var target = (S.fit === 'slim' ? -1.2 : S.fit === 'relaxed' ? 2.4 : 0) + bias * 1.5;
    var keys = ['bust', 'chest', 'waist', 'hip'];
    var scored = [];

    for (var i = 0; i < R.length; i++) {
      var tot = 0, ws = 0, det = {};
      for (var j = 0; j < keys.length; j++) {
        var k = keys[j], w = cat.wt[k];
        if (!w) continue;
        var cv = R[i][k], bv = body[k];
        if (cv == null || bv == null) continue;
        var delta = cv - bv, dev = delta - target;
        var tol = Math.max(2, cv * 0.025), n = dev / tol;
        tot += (n < 0 ? Math.pow(-n, 1.55) * 1.35 : Math.pow(n, 1.55)) * w;
        ws += w;
        det[k] = { delta: r1(delta), chart: cv, body: bv };
      }
      if (ws) scored.push({ i: i, row: R[i], size: R[i].size, score: tot / ws, det: det });
    }
    if (!scored.length) return null;
    scored.sort(function (a, b) { return a.score - b.score; });

    var best = scored[0], next = scored[1] || null;
    var shape = S.shape || shapeOf(body, S.gender);
    var over = null;

    /* A hip cannot be let out; a bodice can be taken in. */
    if (S.category === 'dresses' || S.category === 'abaya') {
      if ((shape === 'pear' || shape === 'bottomHourglass' || shape === 'spoon') &&
          best.det.hip && best.det.hip.delta < 0 && next && next.i > best.i) {
        var sw = best; best = next; next = sw;
        over = S.lang === 'ar'
          ? 'رفعنا المقاس ليناسب الأرداف — تضييق الجزء العلوي أسهل بكثير من توسيع الأرداف.'
          : 'Sized up so the hip fits — the bodice can be taken in far more easily than a hip can be let out.';
      }
    }

    var need = 0, got = 0;
    for (var kk in cat.wt) { if (!cat.wt[kk]) continue; need++; if (body[kk] != null) got++; }
    var cov = need ? got / need : 0.5;
    var gap = next ? Math.min(1, Math.abs(next.score - best.score) / 0.8) : 0.6;
    var conf = Math.round(42 + cov * 34 + gap * 20 - (body.estimated ? 16 : 0));
    conf = Math.max(35, Math.min(96, conf));

    var arLab = { 'Too tight': 'ضيّق جدًا', 'Snug': 'ضيّق قليلًا', 'Too loose': 'واسع جدًا', 'Roomy': 'واسع قليلًا', 'Great fit': 'مقاس ممتاز' };
    var fitRows = [];
    for (var mk in best.det) {
      var d = best.det[mk];
      var tight = (mk === 'waist' || mk === 'hip') ? -1.5 : -2.5;
      var loose = (mk === 'waist' || mk === 'hip') ? 4.5 : 6.5;
      var lab, tone;
      if (d.delta < tight - 3) { lab = 'Too tight'; tone = 'bad'; }
      else if (d.delta < tight) { lab = 'Snug'; tone = 'warn'; }
      else if (d.delta > loose + 4) { lab = 'Too loose'; tone = 'bad'; }
      else if (d.delta > loose) { lab = 'Roomy'; tone = 'warn'; }
      else { lab = 'Great fit'; tone = 'good'; }
      fitRows.push({ key: mk, label: t(mk) || mk, yours: r1(d.body), size: r1(d.chart),
        delta: r1(d.delta), fit: S.lang === 'ar' ? arLab[lab] : lab, tone: tone });
    }

    return { size: best.size, row: best.row, i: best.i,
      order: R.map(function (x) { return x.size; }),
      alt: next ? next.size : null, altDir: next ? (next.i > best.i ? 'up' : 'down') : null,
      conf: conf, shape: shape, fitRows: fitRows, body: body,
      notes: notes(shape, over, best.i, R.length, body) };
  }

  function notes(shape, over, idx, total, body) {
    var out = [], ar = S.lang === 'ar';
    if (over) out.push({ i: '✂️', x: over });

    var mine = REGIONS[S.region] || REGIONS.western;
    var theirs = REGIONS[(CFG.chart && CFG.chart.block) || 'western'] || REGIONS.western;
    if (mine !== theirs) {
      var h = [];
      var dSl = r1(mine.sl - theirs.sl), dSh = r1(mine.sh - theirs.sh),
          dIn = r1(mine.ins - theirs.ins), dTo = r1(mine.to - theirs.to);
      if (dSl <= -1.5) h.push(ar ? 'أكمامًا أطول بنحو ' + Math.abs(dSl).toFixed(1) + ' سم'
                                 : 'sleeves about ' + Math.abs(dSl).toFixed(1) + ' cm long');
      if (dSh <= -1) h.push(ar ? 'درزة كتف تتجاوز نقطة كتفك' : 'the shoulder seam past your shoulder point');
      if (dIn <= -2 && S.category === 'bottoms')
        h.push(ar ? 'طول الساق أطول بنحو ' + Math.abs(dIn).toFixed(0) + ' سم'
                  : 'the inseam roughly ' + Math.abs(dIn).toFixed(0) + ' cm too long');
      if (dTo <= -1.5) h.push(ar ? 'طول جسم زائد' : 'a long body length');
      if (h.length) {
        out.push({ i: '🌍', x: ar
          ? 'قوالبنا مصمّمة على ' + theirs.a + ' وتختلف عن ' + mine.a + '. حتى بالمقاس الصحيح توقّع ' + h.join('، ') + '. هذه تعديلات سريعة ورخيصة — احسب لها حسابًا بدل النزول مقاسًا.'
          : 'We draft on a ' + theirs.l + ' block, which differs from ' + mine.l + '. Even in the right size, expect ' + h.join(', ') + '. These are quick, cheap alterations — budget for them rather than sizing down.' });
      }
    }

    var sp = shapeById(shape, S.gender);
    if (sp) out.push({ i: '👤', x: ar ? sp.adA : sp.ad });

    if (S.category === 'outerwear')
      out.push({ i: '🧥', x: ar ? 'الملابس الخارجية تُقاس فوق ما ترتديه تحتها. مع الطبقات اختر الأوسع.'
                                : 'Outerwear is measured over what you wear underneath. If you layer, the roomier size is usually right.' });
    if (body.estimated)
      out.push({ i: '⚠️', w: 1, x: ar ? 'هذه الأرقام مُقدَّرة. قياسك بشريط القياس يستغرق دقيقتين ويرفع الدقة كثيرًا.'
                                      : 'These numbers were estimated. Taking a tape measure to your bust, waist and hip takes two minutes and raises accuracy a lot.' });
    if (idx === 0)
      out.push({ i: '⚠️', w: 1, x: ar ? 'هذا أصغر مقاس في هذه المجموعة.' : 'This is the smallest size in this range.' });
    if (idx === total - 1)
      out.push({ i: '⚠️', w: 1, x: ar ? 'هذا أكبر مقاس في هذه المجموعة.' : 'This is the largest size in this range.' });
    return out;
  }

  /* Map onto what this style is actually cut in, preferring to go up, and
     always returning the store's own spelling. */
  function stocked(size, order) {
    var av = CFG.availableSizes;
    if (!av || !av.length) return null;
    var byKey = {};
    for (var i = 0; i < av.length; i++) { var k = key(av[i]); if (k && !(k in byKey)) byKey[k] = String(av[i]).trim(); }
    var want = key(size);
    if (want in byKey) return byKey[want] === String(size).trim() ? null : { s: byKey[want], req: size, dir: 'same' };
    var at = -1;
    for (var j = 0; j < order.length; j++) if (key(order[j]) === want) { at = j; break; }
    if (at === -1) return null;
    for (var d = 1; d <= order.length; d++) {
      var u = order[at + d], w = order[at - d];
      if (u != null && key(u) in byKey) return { s: byKey[key(u)], req: size, dir: 'up' };
      if (w != null && key(w) in byKey) return { s: byKey[key(w)], req: size, dir: 'down' };
    }
    return null;
  }

  function sil(w, on) {
    var C = 20, M = 15.5, sh = w[0] * M, bu = w[1] * M, wa = w[2] * M, hi = w[3] * M;
    var f = on ? '#1a1a1a' : '#c5c4be';
    var p = 'M' + (C - sh) + ',12 C' + (C - bu) + ',15 ' + (C - bu) + ',17.5 ' + (C - bu) + ',21 C' +
      (C - wa) + ',24.5 ' + (C - wa) + ',26.5 ' + (C - wa) + ',30 C' + (C - hi) + ',33.5 ' + (C - hi) +
      ',35.5 ' + (C - hi) + ',39 L' + (C - hi * 0.8) + ',48 L' + (C - hi * 0.44) + ',56 L' +
      (C + hi * 0.44) + ',56 L' + (C + hi * 0.8) + ',48 L' + (C + hi) + ',39 C' + (C + hi) + ',35.5 ' +
      (C + wa) + ',33.5 ' + (C + wa) + ',30 C' + (C + wa) + ',26.5 ' + (C + bu) + ',24.5 ' + (C + bu) +
      ',21 C' + (C + bu) + ',17.5 ' + (C + sh) + ',15 ' + (C + sh) + ',12 Z';
    return '<svg viewBox="0 0 40 58" aria-hidden="true"><circle cx="20" cy="5" r="3.7" fill="' + f +
      '"/><rect x="17.3" y="7.6" width="5.4" height="5.2" rx="2" fill="' + f + '"/><path d="' + p +
      '" fill="' + f + '"/></svg>';
  }

  function build() {
    if (el.root) return;
    var n = D.createElement('div');
    n.className = 'ff-root';
    n.innerHTML =
      '<div class="ff-overlay" role="dialog" aria-modal="true" aria-label="Find my size"><div class="ff-modal">' +
      '<div class="ff-head"><div><h2 class="ff-title"></h2><p class="ff-sub"></p></div>' +
      '<div class="ff-head-actions"><button class="ff-iconbtn ff-wide" data-a="lang" type="button">ع</button>' +
      '<button class="ff-iconbtn" data-a="close" aria-label="Close" type="button">✕</button></div></div>' +
      '<div class="ff-steps"></div><div class="ff-body"></div><div class="ff-foot"></div></div></div>';
    D.body.appendChild(n);
    el.root = n;
    el.ov = n.querySelector('.ff-overlay');
    el.modal = n.querySelector('.ff-modal');
    el.title = n.querySelector('.ff-title');
    el.sub = n.querySelector('.ff-sub');
    el.steps = n.querySelector('.ff-steps');
    el.body = n.querySelector('.ff-body');
    el.foot = n.querySelector('.ff-foot');

    n.addEventListener('click', click);
    n.addEventListener('input', function (e) {
      var k = e.target.getAttribute && e.target.getAttribute('data-m');
      if (!k) return;
      S.m[k] = e.target.value;
      if (S.mode === 'estimate') {
        var box = el.body.querySelector('[data-est]');
        if (box) box.innerHTML = estBox();
      }
    });
    n.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      if (e.key === 'Enter' && S.step < 4 && e.target.tagName === 'INPUT') { e.preventDefault(); next(); }
    });
    el.ov.addEventListener('mousedown', function (e) { if (e.target === el.ov) close(); });
  }

  function fresh() {
    var sv = store();
    var b = { step: 0, lang: CFG.lang || 'en', gender: CFG.gender || 'women',
      region: CFG.region || 'gulf', category: CFG.category || 'tops', unit: CFG.unit || 'cm',
      mode: 'tape', build: 'average', fit: 'regular', shape: null, m: {}, err: {} };
    if (sv) {
      ['gender', 'region', 'unit', 'build', 'fit', 'shape', 'mode'].forEach(function (k) {
        if (sv[k] != null) b[k] = sv[k];
      });
      if (sv.m) b.m = sv.m;
      b.had = true;
    }
    return b;
  }

  function render() {
    el.root.setAttribute('dir', S.lang === 'ar' ? 'rtl' : 'ltr');
    el.title.textContent = t('title');
    el.sub.textContent = t('sub');
    el.steps.innerHTML = [0, 1, 2, 3, 4].map(function (i) {
      return '<span class="' + (i <= S.step ? 'ff-done' : '') + '"></span>';
    }).join('');
    el.body.innerHTML = [stepWho, stepMeas, stepShape, stepFit, stepResult][S.step]();
    el.foot.innerHTML = foot();
    el.body.scrollTop = 0;
  }

  function stepWho() {
    var h = '<div class="ff-section"><p class="ff-q">' + t('who') + '</p><div class="ff-grid ff-2">';
    [['women', t('women')], ['men', t('men')]].forEach(function (g) {
      h += '<button class="ff-card' + (S.gender === g[0] ? ' ff-sel' : '') + '" data-a="gender" data-v="' +
        g[0] + '" style="text-align:center"><b>' + g[1] + '</b></button>';
    });
    h += '</div></div><div class="ff-section"><p class="ff-q">' + t('regionQ') + '</p><p class="ff-hint">' +
      t('regionH') + '</p><div class="ff-grid ff-2">';
    Object.keys(REGIONS).forEach(function (id) {
      h += '<button class="ff-card' + (S.region === id ? ' ff-sel' : '') + '" data-a="region" data-v="' +
        id + '"><b>' + esc(S.lang === 'ar' ? REGIONS[id].a : REGIONS[id].l) + '</b></button>';
    });
    return h + '</div>';
  }

  function field(k, label, opt, ph) {
    var u = k === 'weight' ? 'kg' : S.unit, e = S.err[k];
    return '<div class="ff-field' + (e ? ' ff-haserr' : '') + '"><label for="ff-' + k + '">' + esc(label) +
      (opt ? ' <span class="ff-opt">' + t('opt') + '</span>' : '') + '</label><div class="ff-inputwrap">' +
      '<input id="ff-' + k + '" data-m="' + k + '" type="number" inputmode="decimal" step="0.1" value="' +
      esc(S.m[k] == null ? '' : S.m[k]) + '" placeholder="' + esc(ph || '') + '"><span class="ff-unit">' +
      u + '</span></div>' + (e ? '<div class="ff-err">' + esc(e) + '</div>' : '') + '</div>';
  }

  function estBox() {
    var e = estimate();
    if (!e) return '<b>' + t('estWait') + '</b>';
    var g = S.gender === 'men' ? t('chest') + ' ' + e.chest : t('bust') + ' ' + e.bust;
    return '<b>' + t('estIs') + '</b> ' + g + ' ' + t('cm') + ' · ' + t('waist') + ' ' + e.waist + ' ' +
      t('cm') + ' · ' + t('hip') + ' ' + e.hip + ' ' + t('cm');
  }

  function stepMeas() {
    var isW = S.gender !== 'men';
    var h = '<div class="ff-rowhead"><p class="ff-q">' + t('measQ') + '</p><span class="ff-spacer"></span>' +
      '<div class="ff-toggle"><button data-a="unit" data-v="cm" class="' + (S.unit === 'cm' ? 'ff-on' : '') +
      '">cm</button><button data-a="unit" data-v="in" class="' + (S.unit === 'in' ? 'ff-on' : '') +
      '">in</button></div></div><div class="ff-toggle" style="margin-bottom:14px">' +
      '<button data-a="mode" data-v="tape" class="' + (S.mode === 'tape' ? 'ff-on' : '') + '">' + t('tape') +
      '</button><button data-a="mode" data-v="estimate" class="' + (S.mode === 'estimate' ? 'ff-on' : '') +
      '">' + t('est') + '</button></div><p class="ff-hint">' +
      (S.mode === 'estimate' ? t('estH') : t('measH')) + '</p>';

    if (S.mode === 'estimate') {
      h += field('height', t('height'), false, S.unit === 'cm' ? '163' : '64');
      h += field('weight', t('weight'), false, '62');
      h += '<div class="ff-field"><label>' + t('build') + '</label><div class="ff-grid ff-3">';
      [['slight', t('slight')], ['average', t('avg')], ['full', t('full')]].forEach(function (b) {
        h += '<button class="ff-card' + (S.build === b[0] ? ' ff-sel' : '') + '" data-a="build" data-v="' +
          b[0] + '" style="text-align:center"><b>' + b[1] + '</b></button>';
      });
      h += '</div></div><div class="ff-shapedesc" data-est>' + estBox() + '</div>';
    } else {
      h += field('height', t('height'), true, S.unit === 'cm' ? '163' : '64');
      h += field(isW ? 'bust' : 'chest', isW ? t('bust') : t('chest'), false,
        S.unit === 'cm' ? (isW ? '92' : '100') : (isW ? '36' : '39'));
      h += field('waist', t('waist'), false, S.unit === 'cm' ? (isW ? '74' : '86') : (isW ? '29' : '34'));
      h += field('hip', t('hip'), false, S.unit === 'cm' ? (isW ? '98' : '100') : (isW ? '38.5' : '39'));
    }

    h += '<details class="ff-accordion"><summary>' + t('guide') +
      '</summary><div class="ff-acbody ff-hint" style="margin:0">' +
      (isW
        ? '<p style="margin:0 0 8px"><b>' + t('bust') + '</b> — around the fullest part of the chest, tape level, wearing your usual bra.</p>' +
          '<p style="margin:0 0 8px"><b>' + t('waist') + '</b> — the narrowest point of your torso. Breathe out normally.</p>' +
          '<p style="margin:0"><b>' + t('hip') + '</b> — the fullest point around the seat, feet together.</p>'
        : '<p style="margin:0 0 8px"><b>' + t('chest') + '</b> — around the fullest part of the chest, arms relaxed.</p>' +
          '<p style="margin:0 0 8px"><b>' + t('waist') + '</b> — at the natural waist, roughly level with the navel.</p>' +
          '<p style="margin:0"><b>' + t('hip') + '</b> — around the fullest part of the seat.</p>') +
      '</div></details>';
    return h;
  }

  function stepShape() {
    var body = S.mode === 'estimate' ? (estimate() || {}) : bodyCm();
    var auto = shapeOf(body, S.gender);
    if (!S.shape) S.shape = auto;
    var L = S.gender === 'men' ? SM : SW;
    var h = '<p class="ff-q">' + t('shapeQ') + '</p><p class="ff-hint">' + t('shapeH') + '</p><div class="ff-shapes">';
    L.forEach(function (sp) {
      var on = S.shape === sp.id;
      h += '<button class="ff-shape' + (on ? ' ff-sel' : '') + '" data-a="shape" data-v="' + sp.id + '">' +
        (sp.id === auto ? '<i class="ff-auto">' + t('auto') + '</i>' : '') + sil(sp.w, on) +
        '<span>' + esc(S.lang === 'ar' ? sp.a : sp.l) + '</span></button>';
    });
    h += '</div>';
    var cur = shapeById(S.shape, S.gender);
    if (cur) h += '<div class="ff-shapedesc"><b>' + esc(S.lang === 'ar' ? cur.a : cur.l) + '</b> — ' +
      esc(S.lang === 'ar' ? cur.adA : cur.ad) + '<span class="ff-common">' + esc(cur.c) + '</span></div>';
    return h;
  }

  function stepFit() {
    var h = '<div class="ff-section"><p class="ff-q">' + t('fitQ') + '</p><div class="ff-grid ff-3">';
    FITS.forEach(function (f) {
      h += '<button class="ff-card' + (S.fit === f.id ? ' ff-sel' : '') + '" data-a="fit" data-v="' + f.id +
        '" style="text-align:center"><b>' + esc(S.lang === 'ar' ? f.a : f.l) + '</b><small>' + esc(f.d) +
        '</small></button>';
    });
    h += '</div></div>';
    var name = (CFG.chart && CFG.chart.name) || '';
    var note = (CFG.chart && CFG.chart.note) || '';
    if (name) h += '<div class="ff-shapedesc"><b>' + esc(name) + '</b>' + (note ? ' — ' + esc(note) : '') + '</div>';
    return h;
  }

  function stepResult() {
    var r = recommend();
    S.res = r;
    if (!r) return '<p class="ff-hint">We could not work out a size from those numbers. Go back and check them.</p>';

    var cat = CATS[S.category] || CATS.tops;
    var h = '<div class="ff-result-hero"><div class="ff-rlabel">' + t('your') + ' · ' +
      esc(S.lang === 'ar' ? cat.a : cat.l) + '</div><div class="ff-rsize">' + esc(r.size) + '</div>' +
      (CFG.chart && CFG.chart.name ? '<div class="ff-rbrand">' + esc(CFG.chart.name) + '</div>' : '') +
      (r.alt ? '<div class="ff-ralt">' + t('alt') + ': ' + esc(r.alt) + ' (' + t(r.altDir === 'up' ? 'up' : 'down') + ')</div>' : '') +
      '</div><div class="ff-conf"><span>' + t('conf') + '</span><div class="ff-confbar"><i style="width:' +
      r.conf + '%"></i></div><b>' + r.conf + '%</b></div>';

    var st = stocked(r.size, r.order);
    S.apply = st ? st.s : r.size;
    if (st && st.dir !== 'same') {
      h += '<div class="ff-note warn" style="margin-bottom:16px"><span class="ff-nicon">⚠️</span><span>' +
        esc(t('oos').replace('{s}', st.req).replace('{a}', st.s)
          .replace('{d}', st.dir === 'down' ? t('tighter') : t('looser'))) + '</span></div>';
    }

    if (r.fitRows.length) {
      h += '<p class="ff-q" style="margin-bottom:8px">' + t('fits') + '</p><div class="ff-fitrows">';
      r.fitRows.forEach(function (f) {
        h += '<div class="ff-fitrow"><span class="ff-fname">' + esc(f.label) + '</span><span class="ff-fnums">' +
          t('you') + ' ' + f.yours + ' ' + t('cm') + ' · ' + t('size') + ' ' + f.size + ' ' + t('cm') + ' · ' +
          (f.delta >= 0 ? '+' : '') + f.delta + '</span><span class="ff-pill ' + f.tone + '">' + esc(f.fit) +
          '</span></div>';
      });
      h += '</div>';
    }

    if (r.notes.length) {
      h += '<div class="ff-notes">';
      r.notes.forEach(function (n) {
        h += '<div class="ff-note' + (n.w ? ' warn' : '') + '"><span class="ff-nicon">' + n.i +
          '</span><span>' + esc(n.x) + '</span></div>';
      });
      h += '</div>';
    }

    var conv = [['Letter', 'size'], ['EU', 'eu'], ['UK', 'uk'], ['US', 'us'], ['IT', 'it']]
      .filter(function (c) { return r.row[c[1]] != null; });
    if (conv.length > 1) {
      h += '<p class="ff-q" style="margin-bottom:8px">' + t('conv') + '</p><div class="ff-convgrid">';
      conv.forEach(function (c) {
        h += '<div class="ff-conv"><small>' + c[0] + '</small><b>' + esc(r.row[c[1]]) + '</b></div>';
      });
      h += '</div>';
    }

    if (typeof CFG.onResult === 'function' || typeof W.FitFinder.onResult === 'function') {
      h += '<button class="ff-btn" data-a="apply" style="width:100%;margin-bottom:12px">' +
        esc(t('apply').replace('{s}', S.apply)) + '</button>';
    }
    h += '<div style="display:flex;gap:10px;align-items:center"><button class="ff-btn ff-ghost" data-a="save">' +
      t('save') + '</button><span class="ff-saved" data-savedmsg style="display:none">' + t('saved') +
      '</span></div><p class="ff-disclaimer">' + t('disc') + '</p>';
    return h;
  }

  function foot() {
    var h = S.step > 0 ? '<button class="ff-btn ff-ghost" data-a="back">' + t('back') + '</button>' : '';
    h += '<span class="ff-spacer"></span>';
    if (S.step < 4) h += '<button class="ff-btn" data-a="next">' + (S.step === 3 ? t('see') : t('next')) + '</button>';
    else h += '<button class="ff-btn ff-ghost" data-a="restart">' + t('again') + '</button>' +
      '<button class="ff-btn" data-a="close">' + t('done') + '</button>';
    return h;
  }

  function valid() {
    S.err = {};
    var need = S.mode === 'estimate' ? ['height', 'weight']
      : (S.gender === 'men' ? ['chest', 'waist', 'hip'] : ['bust', 'waist', 'hip']);
    var lim = { height: [120, 220], weight: [30, 250], bust: [60, 175], chest: [60, 175],
      waist: [45, 175], hip: [60, 190] };
    need.forEach(function (k) {
      var v = num(k);
      if (v == null) { S.err[k] = t('req'); return; }
      var L = lim[k];
      if (L && (v < L[0] || v > L[1])) S.err[k] = L[0] + '–' + L[1] + (k === 'weight' ? ' kg' : ' cm');
    });
    return !Object.keys(S.err).length;
  }

  function next() {
    if (S.step === 1) { if (!valid()) return render(); S.shape = null; }
    S.step = Math.min(4, S.step + 1);
    render();
  }

  function click(e) {
    var n = e.target.closest ? e.target.closest('[data-a]') : null;
    if (!n || !el.modal.contains(n)) return;
    var a = n.getAttribute('data-a'), v = n.getAttribute('data-v');
    if (a === 'lang') { S.lang = S.lang === 'ar' ? 'en' : 'ar'; n.textContent = S.lang === 'ar' ? 'EN' : 'ع'; return render(); }
    if (a === 'gender') { S.gender = v; S.shape = null; return render(); }
    if (a === 'region') { S.region = v; return render(); }
    if (a === 'build') { S.build = v; return render(); }
    if (a === 'shape') { S.shape = v; return render(); }
    if (a === 'fit') { S.fit = v; return render(); }
    if (a === 'mode') { S.mode = v; S.err = {}; return render(); }
    if (a === 'unit') {
      if (v !== S.unit) {
        ['height', 'bust', 'chest', 'waist', 'hip'].forEach(function (k) {
          var raw = parseFloat(S.m[k]);
          if (!isNaN(raw)) S.m[k] = r1(v === 'in' ? raw / 2.54 : raw * 2.54);
        });
        S.unit = v;
      }
      return render();
    }
    if (a === 'back') { S.step = Math.max(0, S.step - 1); return render(); }
    if (a === 'next') return next();
    if (a === 'restart') { S = fresh(); return render(); }
    if (a === 'close') return close();
    if (a === 'save') {
      store({ gender: S.gender, region: S.region, unit: S.unit, build: S.build, fit: S.fit,
        shape: S.shape, mode: S.mode, m: S.m });
      var m = el.body.querySelector('[data-savedmsg]');
      if (m) m.style.display = '';
      n.disabled = true;
      if (typeof CFG.onSave === 'function') {
        CFG.onSave({ gender: S.gender, region: S.region, shape: S.shape, fit: S.fit,
          measurements: S.res ? S.res.body : bodyCm(),
          recommendation: S.res ? { size: S.res.size, confidence: S.res.conf } : null });
      }
      return;
    }
    if (a === 'apply') {
      var hook = CFG.onResult || W.FitFinder.onResult;
      if (typeof hook === 'function') { try { hook(S.apply || (S.res && S.res.size)); } catch (x) {} }
      return close();
    }
  }

  function open(o) {
    build();
    if (o) for (var k in o) CFG[k] = o[k];
    S = fresh();
    if (o && o.category) S.category = o.category;
    if (S.had && valid()) S.step = 4;
    S.err = {};
    render();
    el.ov.classList.add('ff-open');
    D.documentElement.style.overflow = 'hidden';
    var f = el.body.querySelector('input, button');
    if (f) setTimeout(function () { f.focus(); }, 60);
  }

  function close() {
    if (!el.ov) return;
    el.ov.classList.remove('ff-open');
    D.documentElement.style.overflow = '';
  }

  W.FitFinder = {
    init: function (c) {
      CFG = c || {};
      CFG.chart = CFG.chart || CFG.customChart || {};
      CFG.region = CFG.region || CFG.defaultRegion || 'gulf';
      build();
      D.addEventListener('click', function (e) {
        var trg = e.target.closest && e.target.closest('[data-fitfinder-open]');
        if (trg) { e.preventDefault(); open({}); }
      });
    },
    open: open,
    close: close
  };
})(window, document);
